import styled from 'styled-components';

export const ContentWrapper = styled.div`
  text-align: center;
  margin-top: 96px !important;
  margin-bottom: 22px !important;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media only screen and (max-width: 767px) {
    margin-top: 22px !important;
    margin-bottom: 0 !important
  }
`;

export const HeaderTitle = styled.h3`
  font-size: 56px;
  font-weight: 700;
  line-height: 64px;
  margin: 0;

  @media only screen and (max-width: 767px) {
    font-size: 28px;
    font-weight: 700;
    line-height: 36px;
  }
`;

export const SubTitle = styled.h3`
  font-size: 56px;
  font-weight: 400;
  line-height: 64px;
  margin: 0;

  @media only screen and (max-width: 767px) {
    font-size: 28px;
    font-weight: 400;
    line-height: 36px;
  }
`;

export const SummaryText = styled.span`
  font-size: 28px;
  font-weight: 400;
  line-height: 32px;
  margin-top: 32px;

  @media only screen and (max-width: 767px) {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    margin: 0 26px 0 12px;
  }
`;
